import { IMiniGameProps } from '../../../../../../typings/common';
import { BGScratch, BonusScratchGif } from '../../../../../assets';
import BonusGameCard from './BonusGameCard';

function BGScratchGame({
	isSmall,
	onStartGame,
	onRequireLogin,
	canPlay,
	config,
	miniGameData,
	playerLevel,
}: IMiniGameProps) {
	return (
		<BonusGameCard
			isSmall={isSmall}
			onStartGame={onStartGame}
			onRequireLogin={onRequireLogin}
			canPlay={canPlay}
			config={config}
			miniGameData={miniGameData}
			playerLevel={playerLevel}
			titleSource={BGScratch}
			thumbSource={BonusScratchGif}
			launchPath='/scratch/bowaPlayer.html'
			cooldownHours={8}
			freePlayTitleFontSize={13}
			infoPaddingVertical={4}
		/>
	);
}

export default BGScratchGame;
